import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import TabFooter from 'root/components/TabFooter';
import t from 'common/i18n';
import useCurrentPage from '../../hooks/useCurrentPage';
import { getInternalPath } from '../../utils';
import { useUI, useSelectedAsset } from '../../getty-selectors';
import { useAssets } from '../../selectors';
import PurchaseButton from './PurchaseButton';
import SVG_ICONS from '~/assets/icons/icons';

export default ({ togglePanel, uploadAsset, purchaseAsset, source, routes }) => {
  const history = useHistory();
  const { selected } = useAssets(source);
  const { purchasedUrl } = useSelectedAsset(source);
  const { isPurchasePage } = useCurrentPage(source, routes);
  const { isFiltersPanelOpen, purchaseInProgress } = useUI(source);

  const secondaryButtonClick = useCallback(() => {
    history.push(getInternalPath(source, routes.PURCHASE));
    if (isFiltersPanelOpen) {
      togglePanel();
    }
  }, [history, isFiltersPanelOpen, routes.PURCHASE, source, togglePanel]);

  const handleUploadAsset = useCallback(() => {
    uploadAsset({ files: [purchasedUrl] });
  }, [uploadAsset, purchasedUrl]);

  return (
    <TabFooter
      showActionButton={selected && !isPurchasePage}
      actionButtonActive
      actionButtonText={t(`${source}.buttons.next`)}
      actionButtonIcon={SVG_ICONS.ARROW_FORWARD}
      secondaryButton={
        isPurchasePage && <PurchaseButton source={source} purchaseAsset={purchaseAsset} uploadAsset={handleUploadAsset} inProgress={purchaseInProgress} />
      }
      uploadButtonHandler={secondaryButtonClick}
    ></TabFooter>
  );
};
